export default __webpack_public_path__ + "static/live-like-a-local-3-91322fa8b3726fff3aed31b4a31a9037.png";